import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import { TooltipHost, DirectionalHint } from "@fluentui/react";
import styles from "./Layout.module.css";
import { authMS, authLOCAL, authGOOGLE } from "../../authConfig";
import { useMsal } from "./../../MsalContext";
import { LoginButton } from "../../components/LoginButton";
import { AccountInfo, AuthenticationResult } from "@azure/msal-browser";
import kognifyLogo from "../../assets/kognify_logo.svg";
import loginLoc from "../../assets/Font_Awesome_5_Solid_Envelope.svg";
import LoginMS from "../../assets/Microsoft.svg";
import loginGoo from "../../assets/google.svg";
import linkedinLogo from "../../assets/linkedin.svg";
import AutonomousAP from "../../components/marketing/AutonomousAP";
import AutonomousCallCenter from "../../components/marketing/AutonomousCallCenter";
import { ScrollDownAnimatedArrows } from "../../components/ScrollDownAnimatedArrows/ScrollDownAnimatedArrows";
import MainAccordionSideBySide from "../../components/marketing/MainAccordionSideBySide";
import { getStoryPreference, getRedeemSpaceName, getTokenMail, getAnonToken, getUrlUid, getRedeemToken, generateRandomString, checkPathForInfoPages } from "./LayoutTooling";
import { IoMail } from "react-icons/io5";
import NavLogBut from "../../components/marketing/NavLogBut";
import { landStoryIds, storyNavRes} from "../../interfaces";
import { a } from "@react-spring/web";


const ProductsLanding = () => {
    const [activeSlide, setActiveSlide] = useState<number>(0);
    const [activeStory, setActiveStory] = useState<storyNavRes>(getStoryPreference());

    useEffect(() => {
        const onScroll = () => {
            if (window.scrollY < 70) {
                setActiveSlide(0);
            } else {
                setActiveSlide(1);
            }
        };
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => {
            window.removeEventListener("scroll", onScroll);
        };
    }, []);

    const changeStory = (storyId: landStoryIds) => {
        setActiveStory(prev => ({
                ...prev,
                storyid: storyId
            })
        );
        setTimeout(() => {
            window.scrollTo({ top: window.innerHeight, behavior: "smooth" });
        }, 300);
    }

    useEffect(() => {
        if (window.location.pathname?.toLowerCase().includes("/details/callcenter")) {
            if (activeStory.storyid !== "acc") changeStory("acc");

        } else if (window.location.pathname?.toLowerCase().includes("/details/accounting")) {
            if (activeStory.storyid !== "aap") changeStory("aap");
        }
    }, [window.location.pathname]);

    const navToStory = (storyId: landStoryIds) => {
        if (activeStory.storyid !== storyId) {
            if (storyId === "acc" && window.location.pathname?.toLowerCase().includes("/details/callcenter") == false) {
                window.location.href = `${window.location.origin}/details/callcenter`;
            } else if (storyId === "aap" && window.location.pathname?.toLowerCase().includes("/details/accounting") == false) {
                window.location.href = `${window.location.origin}/details/accounting`;
            }
        }
    }
    const historyReplaceState = (storyId: landStoryIds) => {
        if ((activeStory.storyid || "") !== "" ) {
            import.meta.env.DEV && console.log("‹replace_state›", storyId);
            if (storyId === "acc") {
                if(window.location.pathname?.toLowerCase().includes("/details/callcenter") == false){
                    window.history.replaceState({}, "", `${window.location.origin}/details/callcenter`);
                    changeStory("acc");
                } else {

                    changeStory("acc");
                    setTimeout(() => {
                        window.scrollTo({ top: window.innerHeight, behavior: "smooth" });
                    }, 300);
                }

            } else if (storyId === "aap") {
                if(window.location.pathname?.toLowerCase().includes("/details/accounting") == false){
                    window.history.replaceState({}, "", `${window.location.origin}/details/accounting`);
                    changeStory("aap");
                } else {
                    changeStory("aap");
                    setTimeout(() => {
                        window.scrollTo({ top: window.innerHeight, behavior: "smooth" });
                    }, 300);
                }

            }
        }
    }
    return (
        <div className={styles.layout}>
            <div className={styles.accordionTopRight}>
                <NavLogBut displayText="Login / Signup" />
            </div>
            <header className={styles.header} role={"banner"}/>
                <div className={styles.area}>
                    <div className={styles.loginContainer} id="kgnfLoginCont">
                        <img src={kognifyLogo} className={styles.kognifyBannerInfo}/>

                        <div className={styles.headerInfoCard}>We offer high precision autonomous ai solutions with enterprise level security & compliance.</div>

                        <div className={styles.headerInfoCardTwo}>Test our flagship products immediately without registration:
                            <div className={styles.accordionTopRightInfo}>
                                <MainAccordionSideBySide activeStoryId={activeStory.storyid} changeStory={historyReplaceState} />
                            </div>
                        </div>
                        <div className={styles.contactIcons}>
                            <div className={styles.lincontainerinfo} onClick={() => window.open("https://www.linkedin.com/company/kgnf", "_blank")}>
                                <TooltipHost content="Keep up with us in LinkedIn" directionalHint={DirectionalHint.bottomCenter}>
                                    <img src={linkedinLogo} className={styles.linlogo}></img>
                                </TooltipHost>
                            </div>
                            <a href="mailto:hey@kgnfy.com" className={styles.mailcontainer}>
                                <TooltipHost content="Contact us via mail" directionalHint={DirectionalHint.bottomCenter}>
                                    <IoMail size={21} color="#ffff"/>
                                </TooltipHost>
                            </a>
                        </div>

                    </div>

                    {/* decorative background circles */}
                    <ul className={styles.circles}>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                    </ul>
                    {import.meta.env.VITE_LOCAL_ONLY_LOGIN_MODE != "True" && (
                        activeStory.storyid == "acc" ? <AutonomousCallCenter /> : <AutonomousAP />
                    )}
                </div>


        </div>
    );
};

export default ProductsLanding;
